import React from "react";
import "../assets/styles/main.scss";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  className?: string;
};

const Input: React.FC<InputProps> = ({ className, ...props }) => (
  <input className={`input ${className || ""}`} {...props} />
);

export default Input;
